'use strict';

var _regeneratorRuntime = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var CID = require('cids');

var _require = require('./utils'),
    findSources = _require.findSources;

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');

module.exports = configure(function (api) {
  /**
   * @type {import('..').Implements<typeof import('ipfs-core/src/components/files/mv')>}
   */
  function mv() {
    return _mv.apply(this, arguments);
  }

  function _mv() {
    _mv = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _len,
          args,
          _key,
          _findSources,
          sources,
          options,
          res,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = _args[_key];
              }

              _findSources = findSources(args), sources = _findSources.sources, options = _findSources.options;
              _context.next = 4;
              return api.post('files/mv', {
                timeout: options.timeout,
                signal: options.signal,
                searchParams: toUrlSearchParams(_objectSpread({
                  arg: sources.map(function (src) {
                    return CID.isCID(src) ? "/ipfs/".concat(src) : src;
                  })
                }, options)),
                headers: options.headers
              });

            case 4:
              res = _context.sent;
              _context.next = 7;
              return res.text();

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _mv.apply(this, arguments);
  }

  return mv;
});